import React, { useState, useEffect } from "react";
import "./review.scss";

const reviews = [
  {
    name: "Rahul S.",
    text:
      "Best cab service for airport transfers. The driver was waiting for me before my flight landed.",
    avatar: "https://i.pravatar.cc/100?img=12",
  },
  {
    name: "Ananya K.",
    text:
      "Very clean cars and professional behavior. Felt safe traveling solo at night.",
    avatar: "https://i.pravatar.cc/100?img=32",
  },
  {
    name: "Priya M.",
    text:
      "Shirdi trip was effortless. No hidden tolls or parking fees.",
    avatar: "https://i.pravatar.cc/100?img=47",
  },
  {
    name: "Neha L.",
    text:
      "Transparent pricing is the best part. No haggling with drivers.",
    avatar: "https://i.pravatar.cc/100?img=24",
  },
  {
    name: "Rajesh G.",
    text:
      "Reliable and consistent. I always choose PulPit.",
    avatar: "https://i.pravatar.cc/100?img=58",
  },
  {
    name: "Amit T.",
    text:
      "Corporate billing is seamless. My finance team loves it!",
    avatar: "https://i.pravatar.cc/100?img=14",
  },
];

const Review = () => {
  const [showAll, setShowAll] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreen = () => {
      setIsMobile(window.innerWidth <= 600);
    };

    checkScreen();
    window.addEventListener("resize", checkScreen);

    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  const visibleReviews = isMobile && !showAll
    ? reviews.slice(0, 3)
    : reviews;

  return (
    <section className="review-section">
      <div className="review-section__container">
        <h2 className="review-section__heading">
          What Our Riders Say
        </h2>
        <p className="review-section__subheading">
          Real stories from our 10,000+ happy travelers
        </p>

        <div className="review-section__grid">
          {visibleReviews.map((item, index) => (
            <div className="review-card" key={index}>
              <div className="review-card__header">
                <img
                  src={item.avatar}
                  alt={item.name}
                  className="review-card__avatar"
                />
                <span className="review-card__name">{item.name}</span>
              </div>

              <p className="review-card__text">
                “{item.text}”
              </p>
            </div>
          ))}
        </div>

        {/* BUTTON ONLY FOR MOBILE */}
        {isMobile && (
          <div className="review-section__action">
            <button onClick={() => setShowAll(!showAll)}>
              {showAll ? "View less reviews" : "View more reviews"}
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default Review;